<template>
    <ul class="form_list">
        <li class="title">
            앱 예약 활성화
            <v-icon class="btn_tooltip">mdi-alert-circle-outline</v-icon>
            <span class="tooltip_wrap">
                <span class="tooltip">활성화시 고객이 직접 앱을 통해 예약을 할 수 있습니다.</span>
            </span>
        </li>
        <li class="cont">
            <label class="switch_wrap">
                <input type="checkbox" v-model="isActive">
                <span class="slider round"></span>
            </label>
        </li>
    </ul>
</template>


<script>
export default {
    props: {
        value: Boolean,
    },
    data() {
        return {
            isActive: false,
        }
    },
    watch: {
        value: {
            immediate: true,
            handler: function(newValue) {
                this.isActive = newValue
            }
        },
        isActive: {
            immediate: true,
            handler: function(newValue, oldValue) {
                if (newValue == oldValue) { return }
                this.updateValue()
            }
        }
    },
    methods: {
        updateValue() {
            this.$emit('input', this.isActive)
        }
    }
}
</script>